import styled from 'styled-components';
import { sx2CssThemeFn } from '@hotelplan/libs.sx';

interface ISeoTextProps {
  seoText: string;
}

const SeoText = styled.div.attrs<ISeoTextProps>(({ seoText }) => ({
  dangerouslySetInnerHTML: { __html: seoText },
}))<ISeoTextProps>(
  sx2CssThemeFn({
    mt: 6,
    mb: '20px',
    px: [3, 0],
    fontFamily: '"Arial", sans-serif',
    fontSize: 0,
    fontWeight: 'normal',
    p: {
      mt: '10px',
      lineHeight: '1.5',
    },

    ul: {
      my: [3, 4],
      listStyle: 'disc',
      li: {
        mt: [2, 1],
        ml: 3,
      },
    },
    a: {
      color: 'primary',
      display: 'inline',
      '&:hover': {
        textDecoration: 'underline',
      },
    },
    h2: {
      fontFamily: '"Helvetica Neue", sans-serif',
      fontWeight: 'bold',
      fontSize: '18px',
    },
    h3: {
      fontFamily: '"Helvetica Neue", sans-serif',
      fontWeight: 'bold',
      fontSize: '16px',
    },
  })
);

export default SeoText;
